var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.className,style:(_vm.iconStyle),attrs:{"src":("/icons/" + _vm.icon + ".svg"),"alt":("icon-" + _vm.icon),"width":_vm.width,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }